/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BorrowerMedicalProcessDto
 */
export interface BorrowerMedicalProcessDto {
    /**
     * 
     * @type {boolean}
     * @memberof BorrowerMedicalProcessDto
     */
    isSend: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BorrowerMedicalProcessDto
     */
    isComplete: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BorrowerMedicalProcessDto
     */
    isSign: boolean;
    /**
     * 
     * @type {Date}
     * @memberof BorrowerMedicalProcessDto
     */
    sendDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BorrowerMedicalProcessDto
     */
    completeDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BorrowerMedicalProcessDto
     */
    signDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof BorrowerMedicalProcessDto
     */
    isSendForSignature?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof BorrowerMedicalProcessDto
     */
    sendForSignatureDate?: Date;
}

/**
 * Check if a given object implements the BorrowerMedicalProcessDto interface.
 */
export function instanceOfBorrowerMedicalProcessDto(value: object): value is BorrowerMedicalProcessDto {
    if (!('isSend' in value) || value['isSend'] === undefined) return false;
    if (!('isComplete' in value) || value['isComplete'] === undefined) return false;
    if (!('isSign' in value) || value['isSign'] === undefined) return false;
    return true;
}

export function BorrowerMedicalProcessDtoFromJSON(json: any): BorrowerMedicalProcessDto {
    return BorrowerMedicalProcessDtoFromJSONTyped(json, false);
}

export function BorrowerMedicalProcessDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerMedicalProcessDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isSend': json['isSend'],
        'isComplete': json['isComplete'],
        'isSign': json['isSign'],
        'sendDate': json['sendDate'] == null ? undefined : (new Date(json['sendDate'])),
        'completeDate': json['completeDate'] == null ? undefined : (new Date(json['completeDate'])),
        'signDate': json['signDate'] == null ? undefined : (new Date(json['signDate'])),
        'isSendForSignature': json['isSendForSignature'] == null ? undefined : json['isSendForSignature'],
        'sendForSignatureDate': json['sendForSignatureDate'] == null ? undefined : (new Date(json['sendForSignatureDate'])),
    };
}

export function BorrowerMedicalProcessDtoToJSON(json: any): BorrowerMedicalProcessDto {
    return BorrowerMedicalProcessDtoToJSONTyped(json, false);
}

export function BorrowerMedicalProcessDtoToJSONTyped(value?: BorrowerMedicalProcessDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSend': value['isSend'],
        'isComplete': value['isComplete'],
        'isSign': value['isSign'],
        'sendDate': value['sendDate'] == null ? undefined : ((value['sendDate']).toISOString().substring(0,10)),
        'completeDate': value['completeDate'] == null ? undefined : ((value['completeDate']).toISOString().substring(0,10)),
        'signDate': value['signDate'] == null ? undefined : ((value['signDate']).toISOString().substring(0,10)),
        'isSendForSignature': value['isSendForSignature'],
        'sendForSignatureDate': value['sendForSignatureDate'] == null ? undefined : ((value['sendForSignatureDate']).toISOString().substring(0,10)),
    };
}

